import React from 'react';
import styled from 'styled-components';
import Navbar from '../Navbar';
import Footer from '../Footer';
import ReferralsHero from './components/ReferralsHero';
import WhyBecomeAReferral from './components/WhyBecomeAReferral';
import WhoShouldApply from './components/WhoShouldApply';
import HowToStart from './components/HowToStart';
import GotAnyQuestion from './components/GotAnyQuestion';
import JoinNow from './components/JoinNow';

const LandingContainer = styled.div`
  img {
    max-width: 100%;
  }
`;

const Referrals = () => (
  <LandingContainer>
    <Navbar />
    <ReferralsHero />
    <WhyBecomeAReferral />
    <WhoShouldApply />
    <HowToStart />
    <GotAnyQuestion />
    <JoinNow />
    <Footer />
  </LandingContainer>
);

export default Referrals;
